import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const subheadingDefinition: ComponentDefinition = {
  id: 'subheading-experience',
  name: 'Subheading',
  category: 'Basic',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/heading-2.svg',
  variables: {
    content: {
      displayName: 'Content',
      type: 'Text',
      defaultValue: 'Subeading text',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    size: {
      displayName: 'Size',
      type: 'Text',
      defaultValue: 'typo-subheading-medium',
      group: 'style',
      validations: {
        in: [
          { value: 'typo-subheading-medium', displayName: 'Medium' },
          { value: 'typo-subheading-small', displayName: 'Small' },
        ],
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    color: {
      displayName: 'Color',
      type: 'Text',
      defaultValue: 'text-text-dark-purple',
      group: 'style',
      validations: {
        in: [
          { value: 'text-text-dark-purple', displayName: 'Purple' },
          { value: 'text-text-white', displayName: 'White' },
          { value: 'text-text-white-on-dark', displayName: 'White on dark' },
          { value: 'text-text-grey', displayName: 'Grey' },
          { value: 'text-text-pink-accent', displayName: 'Pink' },
          { value: 'text-text-link-blue', displayName: 'Link blue' },
        ],
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    textAlign: {
      displayName: 'Text align',
      type: 'Text',
      defaultValue: 'text-center',
      group: 'style',
      validations: {
        in: [
          { value: 'text-left', displayName: 'Left' },
          { value: 'text-center', displayName: 'Center' },
          { value: 'text-right', displayName: 'Right' },
        ],
      },
    },
  },
} as const;
